import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment><path fill="none" d="M0 0h24v24H0z" /><path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z" /></React.Fragment>
, 'Flag');
